//  Internals
import PropTypes from "prop-types";
import React from "react";
import TableLoader from "../../loaders/tableLoader";
//  Externals
import Pagination from "./pagination";
import TableBody from "./tableBody";
import TableHeader from "./tableHeader";
//  Component state
const Table = ({
	columnKey,
	columns,
	tableData,
	payload,
	sortCol,
	setCurrentPage,
	setCurrentLimit,
	loading = false,
	filterValue,
	filterDate,
	tabChangeCounter,
}) => {
	return (
		<>
			<div className="custom-table">
				<div className="table-responsive">
					<table className="table row-border nowrap common-dataTable">
						<TableHeader
							columns={columns}
							columnKey={columnKey}
							sortCol={sortCol}
							filterValue={filterValue}
							filterDate={filterDate}
							tabChangeCounter={tabChangeCounter}
							payload={payload}
						/>
						{loading ? (
							<TableLoader colspan={columns?.length} />
						) : (
							<TableBody
								columns={columns}
								columnKey={columnKey}
								tableData={tableData}
							/>
						)}
					</table>
				</div>
			</div>
			<Pagination
				columnKey={columnKey}
				tableData={tableData}
				setCurrentPage={setCurrentPage}
				setCurrentLimit={setCurrentLimit}
			/>
		</>
	);
};

/******************************************************************************************
@Purpose    :   To validate the props
*******************************************************************************************/
PropTypes.propTypes = {
	columns: PropTypes.array.isRequired,
	columnKey: PropTypes.string.isRequired,
	onColumnSettings: PropTypes.func.isRequired,
	showColumnSettings: PropTypes.bool.isRequired,
};

export default Table;
